const MELBOURNE_CADENCE_TIME = new Intl.DateTimeFormat('en-AU', {
  timeZone: 'Australia/Melbourne',
  hour: 'numeric',
  minute: '2-digit',
});

export type AdminSecurityOperation = 'setup' | 'enable' | 'disable' | 'backup' | 'logout';

export function updateInFlightOperations(
  current: ReadonlySet<AdminSecurityOperation>,
  operation: AdminSecurityOperation,
  inFlight: boolean,
): ReadonlySet<AdminSecurityOperation> {
  const next = new Set(current);
  if (inFlight) next.add(operation);
  else next.delete(operation);
  return next;
}

export function backupCadence(cron: string, referenceDate = new Date()): string {
  const [minute, hour, dayOfMonth, month, dayOfWeek] = cron.trim().split(/\s+/);
  if (
    dayOfMonth === '*' &&
    month === '*' &&
    dayOfWeek === '*' &&
    /^\d+$/.test(minute) &&
    /^\d+$/.test(hour)
  ) {
    const runAt = new Date(
      Date.UTC(
        referenceDate.getUTCFullYear(),
        referenceDate.getUTCMonth(),
        referenceDate.getUTCDate(),
        Number(hour),
        Number(minute),
      ),
    );
    const utcTime = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')} UTC`;
    return `every day at ${MELBOURNE_CADENCE_TIME.format(runAt)} Melbourne time (${utcTime})`;
  }
  return `on the configured ${cron} UTC schedule`;
}
